import {SearchableRow} from "./types";

export function dataSearch<T>(rows: SearchableRow<T>[], search: string) {
  if (search.trim().length == 0) {
    return rows
  }
  return rows.filter(row => row._searchable.includes(search.trim().toLowerCase()))
}

export function prepareSearchableString<T>(row: T, searchProperties: (keyof T)[]): string {
  return searchProperties
    .map(property => (row[property] ?? '').toString())
    .join('|')
    .toLowerCase()
}

export function enrichRowWithSearchableString<T>(rows: T[], searchProperties: (keyof T)[]): SearchableRow<T>[] {
  return rows.map((row) => {
    return {
      ...row,
      _searchable: prepareSearchableString(row, searchProperties),
    }
  })
}